import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {procedurePageUrl} from 'procedures/network/procedureUrls';
import ProcedurePageLink from 'procedures/ProcedurePageLink';

import {ProcessTaskProcedureInfoGraphQL_ProcessTaskNode_procedureRun_ProcedureRunNode_templateProcedureFlowchartVersion as TemplateProcedureFlowchartVersionGql} from '../../graphql-fragments/processes/__generated/ProcessTaskProcedureInfoGraphQL';

interface ProcedurePageLinkForProcedureRunProps {
  procedureRun: {
    templateProcedureFlowchartVersion: TemplateProcedureFlowchartVersionGql;
  };
  className?: string;
}

export default function ProcedurePageLinkForProcedureRun(
  props: ProcedurePageLinkForProcedureRunProps
): JSX.Element | null {
  const templateProcedureFlowchartVersion = props.procedureRun.templateProcedureFlowchartVersion;
  if (isInaccessible(templateProcedureFlowchartVersion)) {
    return <>(No access)</>;
  }
  const parent = templateProcedureFlowchartVersion.procedureFlowchart?.parent;
  if (parent) {
    return (
      <ProcedurePageLink className={props.className} href={procedurePageUrl(parent.id)}>
        {parent.name}
      </ProcedurePageLink>
    );
  } else {
    return null;
  }
}
